var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgQuora = function SvgQuora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4.923 0 0 4.925 0 11s4.924 11 11 11c6.075 0 11-4.925 11-11S17.075 0 11 0Zm.93 16.063a6.053 6.053 0 0 1-1.55.207c-3.022 0-5.98-2.412-5.98-5.918 0-3.54 2.957-5.952 5.98-5.952 3.073 0 6.002 2.394 6.002 5.951a5.76 5.76 0 0 1-2.265 4.626c.433.65.88 1.082 1.5 1.082.678 0 .952-.524.998-.935h.884c.05.548-.223 2.822-2.693 2.822-1.494 0-2.285-.867-2.878-1.882l.002-.001Zm-.563-1.101c-.47-.923-1.02-1.856-2.094-1.856-.205 0-.41.034-.598.118l-.364-.728c.444-.383 1.162-.686 2.086-.686 1.437 0 2.174.694 2.76 1.577.347-.754.51-1.773.51-3.036 0-3.152-.985-4.77-3.287-4.77-2.269 0-3.251 1.618-3.251 4.77 0 3.136.982 4.738 3.25 4.738.362 0 .688-.039.988-.127Z"
  })));
};

export default SvgQuora;